import React from "react";

const BulkActionToolbar: React.FC<{ visible: boolean; scrolled?: boolean; children: React.ReactNode }> = ({ visible, scrolled, children }) => {
    return (
        <div className={`bulk-action-toolbar ${visible ? 'visible' : ''} ${scrolled ? 'scrolled' : ''}`}>
            {children}
        </div>
    );
};

export default BulkActionToolbar;